// src/routes/ProtectedRouteLogin.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { isAccessTokenValid } from "../../api/auth";

function ProtectedRouteLogin({ children }) {
  const isAuthenticated = isAccessTokenValid();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRouteLogin;